<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user.avatar" [src]="user.avatar">
        <mat-icon class="text-on-primary"  *ngIf="!showAvatar || !user.avatar" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">

    <ng-container *ngIf="showAddToHomeScreen | async">
        <button mat-menu-item (click)="addToHomeScreen()">
            <mat-icon [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>
            <span>Add to Home Screen</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
    </ng-container>

    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>

</mat-menu>